import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { ImageModule } from '@ux/components/image/image.module';
import { SlidersModule } from '@shared/sliders/sliders.module';
import { HomeSectionListComponent } from '@shared/home-sections/components/home-section-list/home-section-list.component';
import { SectionTextComponent } from '@shared/home-sections/components/section-text/section-text.component';
import { TravelLoaderComponent } from '@ux/components/travel-loader/travel-loader.component';
import { SwipeUpModule } from '@ux/components/swipe-up/swipe-up.module';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { ButtonLinkDsComponent } from '@design-system/components/molecules/button-link/button-link.component';
import { BenefitsModule } from '@shared/benefits/benefits.module';

@NgModule({
  declarations: [
    HomeSectionListComponent,
    SectionTextComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    GlobalPipesModule,
    ImageModule,
    SlidersModule,
    SwipeUpModule,
    TravelLoaderComponent,
    TypographyDsComponent,
    ButtonLinkDsComponent,
    BenefitsModule
  ],
  exports: [
    HomeSectionListComponent
  ],
  providers: []
})
export class HomeSectionsModule { }
